import {Component, OnInit, Inject, OnDestroy, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AuthService, ApiService, TrackingService, PdfdataService} from 'src/app/services/service.index';
import {ActivatedRoute, Router} from '@angular/router';
import {DOCUMENT} from '@angular/common';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {WINDOW} from 'src/app/services/window.service';
import {AppLockSessionComponent} from 'src/app/shared/app-lock-session/app-lock-session.component';
import {DateUtilsService} from 'src/app/services/date-utils.service';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import { Location } from '@angular/common';
import {loaderConfig} from 'src/app/config/loader';

// NGRX
import {Store} from '@ngrx/store';
import {AppState} from 'src/app/app.reducer';
import {FineModel} from 'src/app/store/fine.model';
import {SetFineAction, UnsetFineAction} from 'src/app/store/fine.actions';

import {PersistFineService} from 'src/app/services/persist.fine.service';
import {filter} from 'rxjs/operators';
import {Subscription} from 'rxjs';


/**
 * ViewfineComponent
 *
 * @author Fran Aragon
 *
 * User Area, to show data fine
 */
@Component({
    selector: 'app-viewfine',
    templateUrl: './viewfine.component.html',
    styleUrls: ['./viewfine.component.css']
})
export class ViewfineComponent implements OnInit, OnDestroy {

    loaderOptions: any = loaderConfig;

    /**
     * Session hash
     */
    private hash: string;

    /**
     * Param hash
     */
    private param_hash: string;

    /**
     * checksesInterval
     */
    private checksesInterval: any;

    /**
     * Fine data
     */
    public finedata: any;

    /**
     * State of fine management
     */
    public estado: string;

    /**
     * Message State of fine management
     */
    public estadoMsj: string;

    /**
     * Url Pdf of fine
     */
    public filePdfUrl: any;

    /**
     * Url Pdf of paid fine
     */
    public filePdfUrlPagado: any;

    /**
     * Url Pdf of justificantePagoOrganismo
     */
    public justificantePagoOrganismo: any;

    /**
     * Indicates if the payment time of the fine has expired
     */
    public timeExpires: boolean = false;

    /**
     * Data using to show in popups
     */
    public data2popups: any;

    /**
     * Data using to show in nopago-instrucciones
     */
    public data2nopay: any;

    /**
     * Indicates if the payment time with disccount of the fine has expired
     */
    public isprontopagofine: boolean = true;

    /**
     * Indicate if the type of comunication
     */
    public tipoEnlace: any;

    /**
     * Indicate if hasDiscount
     */
    public hasDiscount: boolean = false;

    /**
     * modal that lock a session
     */
    @ViewChild('lockSession') private lockSession: AppLockSessionComponent;

    private subscription: Subscription = new Subscription();
    public isProcessingPay: boolean = false;

    /**
     * Indicate role of logged user (0: Gestor Flota, 1: Conductor)
     */
    public rolAcceso: number;

    /**
     * Indicate role who has permission to opperate fine (0: Gestor Flota, 1: Conductor)
     */
    public rolPermiso: number;

    /**
     * Indicate state of enlace (1: enviado, 2: pagado, 3: identificado, 4: compartido)
     */
    public acceso: number;

    public timeOut =  false;
    public diffDays: number;
    public diffHrs: number;
    public diffMins: number;
    public files = [];
    public backToFineGroup = false;
    public summary = [];
    public totalAmount = 0;
    public totalFees = 0;
    public vat = 0;
    public expedienteActual: any;
    public responseIndex = 0;
    public actualFine: any;

    /**
     * @ignore
     */
    constructor(private http: HttpClient,
                private router: Router,
                private route: ActivatedRoute,
                private apiService: ApiService,
                private authService: AuthService,
                @Inject(DOCUMENT) private _document,
                @Inject(WINDOW) private window: Window,
                private translate: TranslateService,
                private trackingService: TrackingService,
                private pdfdataService: PdfdataService,
                private toastr: ToastrService,
                private ngxLoader: NgxUiLoaderService,
                private store: Store<AppState>,
                private persistFineService: PersistFineService,
                private location: Location) {

        this.hash = this.authService.getHash();

        this.route.params.subscribe(params => {
            this.param_hash = params['hash'];
        });
    }

    /**
     * Using api Service get fine data on init and check state, set URL PDF, and dates of comunications
     */
    ngOnInit() {
        localStorage.removeItem('summary');
        if (localStorage.getItem('expedientes') === undefined) {
            if (JSON.parse(localStorage.getItem('expedientes')).length > 1) {
                this.files = JSON.parse(localStorage.getItem('expedientes'));
            }
        }
        this.expedienteActual = JSON.parse(localStorage.getItem('expedientes'))[0];

        // if session hash is different from hash of route eject from session to login page.
        if (this.hash !== this.param_hash) {
            this.lockSession.open();
            return false;
        }

        this.checksesInterval = setInterval(() => {
            this.hash = this.authService.getHash();
            if (this.hash !== this.param_hash) {
                this.lockSession.open();
                clearInterval(this.checksesInterval);
                return false;
            }

        }, 1000 * 60);

        this.subscription = this.store.select('fine_state')
            .pipe(filter(fine_state => fine_state.fine != null))
            .subscribe(fine_state => {
                if (fine_state.fine.isProcessingPay) {
                    this.isProcessingPay = fine_state.fine.isProcessingPay;
                }
            });

        this.ngxLoader.start();
        this.apiService.getFineData(`${this.hash}`, `${this.files[0]}`)
            .subscribe((response: any) => {

                    if (response[0] !== undefined) {
                        this.finedata = response[0];
                        this.backToFineGroup = true;
                        for (let i = 0; i < response.length; i++) {
                            if (response[i].expedienteGesthispania === this.expedienteActual) {
                                this.actualFine = response[i];
                            }
                        }
                    } else {
                        this.finedata = response;
                        this.actualFine = response;
                    }
                    for (let i = 0; i < response.length; i++) {
                        if (response[i].expedienteGesthispania === this.expedienteActual) {
                            this.responseIndex = i;
                        }
                    }

                    const paymentSummary = [];
                    const summaryLine = {
                        expedienteGesthispania: this.actualFine.referencia,
                        matricula: this.actualFine.matricula,
                        lugar: this.actualFine.lugar,
                        tipoInfraccion: this.actualFine.tipoInfraccion,
                        importeBrutoConDescuento: this.actualFine.importeBrutoConDescuento,
                        comisionConDescuento: this.actualFine.comisionConDescuento
                    };
                    paymentSummary.push(summaryLine);
                    this.summary.forEach((value) => {
                        this.totalAmount += value.importeBrutoConDescuento;
                        this.totalFees += value.comisionConDescuento;
                    });
                    this.vat = this.totalFees * 23 / 100;

                    localStorage.setItem('summary', JSON.stringify(paymentSummary));

                    this.estado = this.actualFine.estado;

                    // escape caracteres before persist data
                    let lugar: string;
                    if (this.actualFine.lugar != null) {
                        lugar = this.actualFine.lugar.replace(/[^\w\s]/gi, ' ');
                    } else {
                        lugar = this.actualFine.lugar;
                    }

                    let cliente: string;
                    if (this.actualFine.cliente != null) {
                        cliente = this.actualFine.cliente.replace(/[^\w\s]/gi, ' ');
                    } else {
                        cliente = this.actualFine.cliente;
                    }


                    // store
                    const fineObject = new FineModel({
                        cliente: cliente,
                        contrato: this.actualFine.contrato,
                        fechaInicioContrato: this.actualFine.fechaInicioContrato,
                        fechaFinContrato: this.actualFine.fechaFinContrato,
                        expedienteGesthispania: this.actualFine.expedienteGesthispania,
                        nombreOrganismo: this.actualFine.nombreOrganismo,
                        codigoSancion: this.actualFine.codigoSancion,
                        lugar: lugar,
                        matricula: this.actualFine.matricula,
                        tipoInfraccion: this.actualFine.tipoInfraccion,
                        estado: this.actualFine.estado,
                        fechaFinEnlace: this.actualFine.fechaFinEnlace,
                        importeAPagar: this.actualFine.importeAPagar,
                        importePagado: this.actualFine.importePagado,
                        isProcessingPay: this.isProcessingPay,
                        acceso: this.actualFine.acceso,
                        rolAcceso: this.actualFine.rolAcceso,
                        rolPermiso: this.actualFine.rolPermiso,
                        idEnlace: this.actualFine.idEnlace,
                        pagoActivo: this.actualFine.pagoActivo,
                    });

                    const fechaHoraServidor = this.actualFine.fechaHoraServidor.date;
                    const fechaFinEnlace = this.actualFine.fechaFinEnlace.date;
                    const dateExpires = new Date(fechaFinEnlace.replace(' ', 'T'));
                    const nowdate = new Date(fechaHoraServidor.replace(' ', 'T'));
                    if (nowdate.getTime() > dateExpires.getTime()) {
                        this.timeOut = true;
                    } else {
                        const diffMs = Math.abs(dateExpires.getTime() - nowdate.getTime() );
                        this.diffDays = Math.floor(diffMs / 86400000);
                        this.diffHrs = Math.floor((diffMs % 86400000) / 3600000);
                        this.diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
                    }

                    this.rolAcceso = this.actualFine.rolAcceso;
                    this.rolPermiso = this.actualFine.rolPermiso;
                    this.acceso = this.actualFine.acceso;

                    this.store.dispatch(new SetFineAction(fineObject));
                    this.persistFineService.persistData(fineObject);


                    // check if has discount
                    if ((this.actualFine.importeAPagar < this.actualFine.importeDenuncia) || (this.actualFine.importePagado < this.actualFine.importeDenuncia)) {
                        this.hasDiscount = true;
                    }

                    if (this.estado == 'pagado') {
                        const stateMsg: any = this.translate.instant('FinePage.State2');
                        this.estadoMsj = stateMsg;
                        // PDF paid Fine
                        if (response[0] !== undefined) {
                            this.pdfdataService.setURLPdf(response[this.responseIndex].ficheroJustificante, 'paidfine');
                            this.pdfdataService.setURLPdf(response[this.responseIndex].justificanteOrganismo, 'jdp');
                        } else {
                            this.pdfdataService.setURLPdf(response.ficheroJustificante, 'paidfine');
                            this.pdfdataService.setURLPdf(response.justificanteOrganismo, 'jdp');
                        }
                        this.filePdfUrlPagado = this.pdfdataService.getURLPdf('paidfine');
                        this.justificantePagoOrganismo = this.pdfdataService.getURLPdf('jdp');
                    }

                    if (this.estado == 'cerrado') {
                        const stateMsg: any = this.translate.instant('FinePage.State3');
                        this.estadoMsj = stateMsg;
                        this.tipoEnlace = this.actualFine.tipoEnlace;
                    }

                    if (this.estado == 'enviado') {
                        const stateMsg: any = this.translate.instant('FinePage.State1');
                        this.estadoMsj = stateMsg;
                    }

                    // PDF Fine
                    if (response[0] !== undefined) {
                        this.pdfdataService.setURLPdf(response[this.responseIndex].ficheroMulta, 'fine');
                    } else {
                        this.pdfdataService.setURLPdf(response.ficheroMulta, 'fine');
                    }

                    this.filePdfUrl = this.pdfdataService.getURLPdf('fine');

                    if (this.actualFine.tipoEnlace == '1COM' || this.actualFine.tipoEnlace == '2COM') {
                        // date expiration control
                        if (this.actualFine.fechaFinEnlace != null && this.actualFine.fechaHoraServidor != null) {
                            let dateExpiration = this.actualFine.fechaFinEnlace.date;
                            let datenow = this.actualFine.fechaHoraServidor.date;
                            let dateExpiresf = new Date(dateExpiration.replace(' ', 'T'));
                            let datenowf = new Date(datenow.replace(' ', 'T'));

                            if (datenowf.getTime() > dateExpiresf.getTime()) {
                                this.timeExpires = true;
                            }

                        } else {
                            this.timeExpires = true;
                            const errMsg: any = this.translate.instant('ErrorsMessages.DateErr');
                            this.toastr.error(errMsg);
                        }
                    }

                    if (this.actualFine.tipoEnlace == '2COM') {
                        // is pronto pago ?
                        if (this.actualFine.fechaProntoPago != null && this.actualFine.fechaHoraServidor != null) {
                            let dateProntoPago = this.actualFine.fechaProntoPago.date;
                            let datenow = this.actualFine.fechaHoraServidor.date;
                            let dateProntoPagof = new Date(dateProntoPago.replace(' ', 'T'));
                            let datenowf = new Date(datenow.replace(' ', 'T'));

                            if (datenowf.getTime() > dateProntoPagof.getTime()) {
                                this.isprontopagofine = false;
                            }

                        } else {
                            this.isprontopagofine = false;
                            const errMsg: any = this.translate.instant('ErrorsMessages.DateErr');
                            this.toastr.error(errMsg);
                        }
                    }

                    this.data2popups = {
                        tipoEnlace: this.actualFine.tipoEnlace,
                        expedienteGesthispania: this.actualFine.expedienteGesthispania,
                        fechaProntoPago: this.actualFine.fechaProntoPago,
                        fechaHoraServidor: this.actualFine.fechaHoraServidor,
                        fechaFinEnlace: this.actualFine.fechaFinEnlace,
                        importeAPagar: this.actualFine.importeAPagar,
                        importeDenuncia: this.actualFine.importeDenuncia,
                        estado: this.actualFine.estado,
                        hasComision: this.actualFine.hasComision,
                        hasServicioEnlaceConductor: this.actualFine.hasServicioEnlaceConductor,
                        acceso: this.actualFine.acceso,
                        rolAcceso: this.actualFine.rolAcceso,
                        rolPermiso: this.actualFine.rolPermiso,
                        tipoInfraccion: this.actualFine.tipoInfraccion,
                        idEnlace: this.actualFine.idEnlace,
                    };

                    this.data2nopay = {
                        organismo: this.actualFine.nombreOrganismo,
                        matricula: this.actualFine.matricula,
                        show: true,
                        hasServicioEnlaceConductor: this.actualFine.hasServicioEnlaceConductor

                    };
                    this.actualFine.timezoneDescriptionPP = DateUtilsService.getTimezoneText(this.actualFine.fechaProntoPago.timezone);
                    this.actualFine.timezoneDescriptionFFE = DateUtilsService.getTimezoneText(this.actualFine.fechaFinEnlace.timezone);

                    this.ngxLoader.stop();
                },
                error => {

                    this.errorEvent(error.status, error.message);
                    this.authService.logout();
                    this.router.navigate([`/app/login/pyf/${this.hash}`], {queryParams: {error: error.status}});

                    this.ngxLoader.stop();

                });
    }

    /**
     * @ignore
     */
    ngOnDestroy() {
        clearInterval(this.checksesInterval);
        this.subscription.unsubscribe();
    }

    /**
     * @ignore
     */
    viewpdf(type, event) {
        this.router.navigate([`/app/viewpdf/${type}/${this.hash}/${this.actualFine.expedienteGesthispania}`]);
        // this.myEvent(event);
    }

    /**
     * Captures component event and sends event data to analytics.
     */
    myEvent(event) {
        if (this.trackingService.getPermissionTracking() == 'all' || this.trackingService.getPermissionTracking() == 'statistics') {

            this.trackingService.setHash(this.hash);

            this.trackingService.actionEvent(event, 'SHOW_FINE');

            // Google Analytics
            let idElement: string = (event.target as Element).id;
            let typeEvent: string = event.type;
            let eventAction: string = 'idelement: ' + idElement + ' - typeEvent: ' + typeEvent;
            // (<any>window).ga('send', 'event', {
            //     eventCategory: 'Fine Page Events',
            //     eventLabel: 'FinePageEvents',
            //     eventAction: eventAction,
            //     eventValue: 10
            // });
        }

    }

    /**
     * Captures component error event and saves it in localstorage using tracking service and sends error event data to analytics.
     */
    errorEvent(status, message) {
        if (this.trackingService.getPermissionTracking() == 'all' || this.trackingService.getPermissionTracking() == 'statistics') {

            this.trackingService.setHash(this.hash);

            this.trackingService.errorEvent(status, message);

            // Google Analytics
            let eventAction: string = 'error message: ' + message + ' - error code status: ' + status;
            // (<any>window).ga('send', 'event', {
            //     eventCategory: 'Fine Page Error Events',
            //     eventLabel: 'FinePageErrorEvents',
            //     eventAction: eventAction,
            //     eventValue: 10
            // });

        }
    }

    showActionButtonContainer(): boolean {
        let allowed = false;
        if (this.timeOut) {
            allowed = false;
        } else {
            if (this.acceso === 1) {
                if (this.rolAcceso === this.rolPermiso) {
                    allowed = true;
                }
            } else {
                if ((this.rolAcceso === 1 || this.rolAcceso === 2) && this.acceso === 4 || this.acceso === 7) {
                    allowed = true;
                }
            }
        }
        return allowed;
    }

    viewFine() {
        this.location.back();
    }

}
